// extracted by mini-css-extract-plugin
export default {"hypnogramPlotMarkersText":"ScoringPlot_hypnogramPlotMarkersText__ZMekq"};